import React from 'react';

import { HStack, Progress, Text, VStack } from '@betterment/samba-react';

interface CompressedProgressBarProps {
  precentage: number;
  step: string;
  currentStep: number;
  totalSteps: number;
}

export const CompressedProgressBar: React.FC<CompressedProgressBarProps> = ({
  precentage,
  step,
  currentStep,
  totalSteps,
}) => {
  return (
    <VStack css={{ width: '100%', py: 'space.200', gap: 'space.100' }}>
      <HStack css={{ justifyContent: 'space-between', width: '100%' }}>
        <Text color="text.weak" variant="text50">
          {step}
        </Text>
        <Text color="text.weak" variant="text50">
          {currentStep}/{totalSteps}
        </Text>
      </HStack>
      <Progress indicatorColor="background.info.strong" value={precentage} />
    </VStack>
  );
};

export default CompressedProgressBar;
